/**
 * MKS-532 — TanStack Query hook behind the composer's "External" checkbox.
 *
 * Cache key is ['comment-audience', projectId] and nothing else: the answer
 * is a property of the PROJECT, so every task's composer on the same project
 * shares one cached row rather than refetching per task. A project's external
 * roster changes rarely, hence the generous `staleTime`.
 */
import { useQuery } from '@tanstack/react-query';
import {
  fetchCommentAudience,
  type CommentAudience,
} from '../services/api/commentAudience';

export function useCommentAudience(projectId: number | null, enabled = true) {
  return useQuery<CommentAudience>({
    queryKey: ['comment-audience', projectId],
    queryFn: () => fetchCommentAudience(projectId as number),
    enabled: enabled && projectId !== null && Number.isFinite(projectId),
    staleTime: 5 * 60_000,
  });
}
